var UserStore = require('./stores/UserStore');
var Raven = require('./Raven');

if (PRODUCTION) {
    Raven
        .config(_RAVEN_DSN, { tags: { version: _VERSION } })
        .install();

    if (UserStore.hasData()) {
        updateRavenContext();
    }
    UserStore.addChangeListener(function () {
        updateRavenContext();
    });

    function updateRavenContext() {
        var context;
        if (UserStore.hasData()) {
            var user = UserStore.getUser();
            context = {
                user: user,
                email: user && user.email,
                relationships: (user && user.relationships) ? user.relationships.map(function (relationship) { return relationship.client_id; }) : []
            };
        }

        Raven.setUserContext(context);
    }
}



// WEBPACK FOOTER //
// ./app/errors.js